/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkOrganizationContactRequest
 */
export interface LinkOrganizationContactRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkOrganizationContactRequest
     */
    contactId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkOrganizationContactRequest
     */
    role?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinkOrganizationContactRequest
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkOrganizationContactRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the LinkOrganizationContactRequest interface.
 */
export function instanceOfLinkOrganizationContactRequest(value: object): value is LinkOrganizationContactRequest {
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    return true;
}

export function LinkOrganizationContactRequestFromJSON(json: any): LinkOrganizationContactRequest {
    return LinkOrganizationContactRequestFromJSONTyped(json, false);
}

export function LinkOrganizationContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkOrganizationContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'role': json['role'] == null ? undefined : json['role'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function LinkOrganizationContactRequestToJSON(json: any): LinkOrganizationContactRequest {
    return LinkOrganizationContactRequestToJSONTyped(json, false);
}

export function LinkOrganizationContactRequestToJSONTyped(value?: LinkOrganizationContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactId': value['contactId'],
        'role': value['role'],
        'isPrimary': value['isPrimary'],
        'notes': value['notes'],
    };
}

